import { render, staticRenderFns } from "./ContentShowControllersRoute.vue?vue&type=template&id=5afb990d&scoped=true&"
import script from "./ContentShowControllersRoute.vue?vue&type=script&lang=js&"
export * from "./ContentShowControllersRoute.vue?vue&type=script&lang=js&"
import style0 from "./ContentShowControllersRoute.vue?vue&type=style&index=0&id=5afb990d&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-2fffd51942/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb990d",
  null
  
)

export default component.exports